import { render } from "./ImportImplantStatement.vue?vue&type=template&id=53f7043e&scoped=true"
import script from "./ImportImplantStatement.vue?vue&type=script&lang=js"
export * from "./ImportImplantStatement.vue?vue&type=script&lang=js"

import "./ImportImplantStatement.vue?vue&type=style&index=0&id=53f7043e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f7043e"]])

export default __exports__